import { Components, Theme } from '@mui/material';

export const formControlLabelStyles: Components<Theme>['MuiFormControlLabel'] =
  {
    styleOverrides: {
      label: {
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 600
      }
    }
  };
